import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpStatusCode } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import { Observable } from 'rxjs';
import { tap } from 'rxjs/operators';
import { AppConfiguration } from '../../core/models/app-configuration.model';

/**
 * Class used for intercept any request error and manage it
 */
@Injectable()
export class ErrorHandlerInterceptor implements HttpInterceptor {
  private static readonly UNAUTHORIZED = 401;
  constructor(private readonly toastrService: ToastrService, private readonly translateService: TranslateService, private readonly appConfig: AppConfiguration) { }

  /**
   * Interceptor that catch any error response and call toast service when server is unreachable or status start with 5xx
   * @param request
   * @param next
   */
  intercept<T>(request: HttpRequest<T>, next: HttpHandler): Observable<HttpEvent<T>> {
    return next.handle(request).pipe(
      tap({
        error: (err: HttpErrorResponse) => {
          if (err.url?.includes(this.appConfig.companyLogo.name)) {
            return;
          }

          if (
            !(
              err.status === ErrorHandlerInterceptor.UNAUTHORIZED &&
              (err.message === '' || err.url?.includes('api/v1/my-account'))
            )
          ) {
            if (err.status === 0) {
              this.showToastrError('main.errors.serverNotReachable');
            } else {
              if (err.status.toString().startsWith('5') && err.status !== HttpStatusCode.GatewayTimeout) {
                this.checkServerErrorAndShowToastr(err.error);
              }
            }
          }
        },
      })
    );
  }

  private checkServerErrorAndShowToastr(error: string | Error): void {
    if (error !== '' && (error as Error).message) {
      this.showToastrError((error as Error).message);
    } else {
      this.showToastrError(error as string);
    }
  }

  /**
   * Show toast with translated message
   * @param msgKey Message key
   * @param values Values if present
   */
  private showToastrError(msgKey: string, values?: { [key: string]: string }): void {
    this.toastrService.error(this.translateService.instant(msgKey, values));
  }
}
